const accessOptions = [
  { key: 'TEAM', label: 'Team', accessType: 'TEAM' },
  { key: 'PUBLIC', label: 'Workplace', accessType: 'PUBLIC' },
  { key: 'PRIVATE', label: 'Private', accessType: 'PRIVATE' },
];

const SEARCH_TIMEOUT = 300;
const DEFAULT_ERROR_MESSAGE = 'Not Found';
const PERMISSON_ERROR_MESSAGE = `You don't have permission`;

enum PortModule {
  SPOT = 'SPOT',
}

enum CargoTypes {
  General = 'GENERAL',
  Haz = 'HAZARDOUS',
}

export enum SearchDebounceMs {
  SEDocuments = 1000,
}

export enum SearchMinLengthForApi {
  SEDocuments = 3,
}

enum Modules {
	INQUIRY = 'INQUIRY',
	INQUIRY_BIDDING = 'INQUIRY_BIDDING',
	RFQ = 'RFQ',
	BIDDING = 'BIDDING',
	CONTAINER_TRACKING = 'CONTAINER_TRACKING',
	IMPORTS = 'IMPORTS',
	RATE_MASTER = 'RATE_MASTER',
	DISCOVER_RATE = 'DISCOVER_RATE',
	MARKUP_CRITERIA = 'MARKUP_CRITERIA',
	SHIPMENT_VENDOR = 'SHIPMENT_VENDOR',
	SHIPMENT_SHIPPER = 'SHIPMENT_SHIPPER',
	USER_MANAGEMENT = 'USER_MANAGEMENT',
	SHIPMENT = 'SHIPMENT',
	SHIPMENT_EXECUTION = 'SHIPMENT_EXECUTION',
	ANALYTICS = 'ANALYTICS',
	CONTAINER_TRIANGULATION = 'CONTAINER_TRIANGULATION',
	AIR_TRACKING = 'AIR_TRACKING',
	HBL_TRACKING = 'HBL_TRACKING',
	CUSTOM_CONFIG = 'CUSTOM_CONFIG',
	SHIPPING_MANAGEMENT = 'SHIPPING_MANAGEMENT',
	SUMMARY_DASHBOARD = 'SUMMARY_DASHBOARD',
	DSR_TEMPLATE = 'DSR_TEMPLATE',
}

export enum LocationTypes {
  PLANT = 'PLANT',
  WAREHOUSE = 'WAREHOUSE',
  FACTORY = 'FACTORY',
}

enum OrgTypes {
  FF = 'FF',
  CHA = 'CHA',
  SHIPPER = 'SHIPPER',
  CUSTOMER = 'CUSTOMER',
  SUPPLIER = 'SUPPLIER',
  SHIPPING_LINE = 'SHIPPING_LINE',
  BREAK_BULK = 'BREAK_BULK',
  TRANSPORTER = 'TRANSPORTER',
  SURVEYOR = 'SURVEYOR',
  CFS_CONTRACTOR = 'CFS_CONTRACTOR',
  ICD_CONTRACTOR = 'ICD_CONTRACTOR',
  INTER_CARTING = 'INTER_CARTING',
  CHILD = 'CHILD',
  PARENT = 'PARENT',
}

enum StakeholderTypes {
	SHIPPER = 'SHIPPER',
	FF = 'FF',
	CUSTOMER = 'CUSTOMER',
	SUPPLIER = 'SUPPLIER',
	SELF = 'SELF',
	TASK_OWNER = 'TASK_OWNER',
	CHA = 'CHA',
	EXPORTER = 'EXPORTER',
	IMPORTER = 'IMPORTER',
	TRANSPORTER = 'TRANSPORTER',
	PARENT = 'PARENT',
	CHILD = 'CHILD',
}

enum VendorTypes {
  FF = 'FF',
  SHIPPING_LINE = 'SHIPPING_LINE',
  CHA = 'CHA',
  CFS_CONTRACTOR = 'CFS_CONTRACTOR',
  ICD_CONTRACTOR = 'ICD_CONTRACTOR',
  BREAK_BULK = 'BREAK_BULK',
  TRANSPORTER = 'TRANSPORTER',
  SURVEYOR = 'SURVEYOR',
  INTER_CARTING = 'INTER_CARTING'
}

const OrgBasedModules = {
  [OrgTypes.CHA]: {
    CONTAINER_TRACKING: 'Container Tracking',
    CONTAINER_TRIANGULATION: 'Container Triangulation',
    AIR_TRACKING: 'Air Tracking',
    HBL_TRACKING: 'HBL Tracking',
  },
  [OrgTypes.SHIPPING_LINE]: {
    RATE_MASTER: 'Rate Master',
    RFQ: 'RFQ',
    CONTAINER_TRACKING: 'Container Tracking',
    CONTAINER_TRIANGULATION: 'Container Triangulation',
    AIR_TRACKING: 'Air Tracking',
    HBL_TRACKING: 'HBL Tracking',
  },
  [OrgTypes.SHIPPER]: {
    INQUIRY: 'Inquiry',
    RATE_MASTER: 'Rate Master',
    CONTAINER_TRACKING: 'Container Tracking',
    RFQ: 'RFQ',
    SHIPMENT_EXECUTION: 'Shipment Execution',
    DISCOVER_RATE: 'Contract Rates',
    CONTAINER_TRIANGULATION: 'Container Triangulation',
    MARKUP_CRITERIA: 'Markup Criteria',
  },
  [OrgTypes.FF]: {
    RFQ: 'RFQ',
    CONTAINER_TRACKING: 'Container Tracking',
    INQUIRY: 'Inquiry',
    MARKUP_CRITERIA: 'Markup Criteria',
    SHIPMENT_EXECUTION: 'Shipment Execution',
    CONTAINER_TRIANGULATION: 'Container Triangulation',
    ANALYTICS: 'Analytics',
    DISCOVER_RATE: 'Contract Rates',
  },
  [OrgTypes.TRANSPORTER]: {
    CONTAINER_TRACKING: 'Container Tracking',
    SHIPMENT_EXECUTION: 'Shipment Execution',
    RATE_MASTER: 'Rate Master',
    INQUIRY: 'Inquiry',
  },
  [OrgTypes.CFS_CONTRACTOR]: {
    CONTAINER_TRACKING: 'Container Tracking',
    SHIPMENT_EXECUTION: 'Shipment Execution',
    RATE_MASTER: 'Rate Master',
    INQUIRY: 'Inquiry',
  },
  [OrgTypes.ICD_CONTRACTOR]: {
    CONTAINER_TRACKING: 'Container Tracking',
    SHIPMENT_EXECUTION: 'Shipment Execution',
    RATE_MASTER: 'Rate Master',
    INQUIRY: 'Inquiry',
  },
  [OrgTypes.SURVEYOR]: {
    CONTAINER_TRACKING: 'Container Tracking',
    SHIPMENT_EXECUTION: 'Shipment Execution',
    RATE_MASTER: 'Rate Master',
    INQUIRY: 'Inquiry',
  },
  [OrgTypes.BREAK_BULK]: {
    CONTAINER_TRACKING: 'Container Tracking',
    SHIPMENT_EXECUTION: 'Shipment Execution',
    RATE_MASTER: 'Rate Master',
    INQUIRY: 'Inquiry',
  },
  [OrgTypes.INTER_CARTING]: {
    CONTAINER_TRACKING: 'Container Tracking',
    SHIPMENT_EXECUTION: 'Shipment Execution',
    RATE_MASTER: 'Rate Master',
    INQUIRY: 'Inquiry',
  },
};

const ModuleToPermissionMap = {
  [OrgTypes.SHIPPER]: { 
    INQUIRY: 'show_inquiry',
    AIR_TRACKING: 'show_air_tracking',
    ANALYTICS: 'show_analytics',
    CUSTOM_CONFIG: 'show_custom_config',
    CONTAINER_TRACKING: 'show_container_tracking',
    CONTAINER_TRIANGULATION: 'show_container_triangulation',
    DOMESTIC: 'show_domestic',
    DISCOVER_RATE: 'show_discover_buy_rates',
    HBL_TRACKING: 'show_hbl_tracking',
    MASTERS: 'show_masters',
    MY_PROFILE: 'show_my_profile',
    RATE_MASTER: 'show_rate_master',
    RFQ: 'show_rfq',
    SHIPMENT_EXECUTION: 'show_shipment_execution_shipper',
    SHIPPING_MANAGEMENT: 'show_shipping_management',
    VESSEL_SCHEDULES: 'show_vessel_schedules',
  }
}

enum AccessType {
  PUBLIC = 'PUBLIC',
  TEAMS = 'TEAM',
}

enum InquiryModes {
  FCL = 'FCL',
  LCL = 'LCL',
  AIRCARGO = 'AIRCARGO',
  TRAILER = 'TRAILER',
  DOMESTIC = 'DOMESTIC',
  RPTL = 'RPTL'
}

enum InquiryType {
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
  TRADE = 'TRADE',
}

enum CargoOperationType {
  STUFFING = 'STUFFING',
  DESTUFFING = 'DESTUFFING',
}

enum LocationType {
  CFS = 'CFS', // Container Freight Station
  FACTORY = 'Factory',
}

enum UserTags {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}
enum UserRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

enum ModesOfService {
	FCL = 'FCL',
	LCL = 'LCL',
	AIR = 'AIR',
  AIRCARGO = 'AIRCARGO',
	TRAILER = 'TRAILER',
	DOMESTIC = 'DOMESTIC',
	RPTL = 'RPTL',
	ISO_TANKS = 'ISO Tanks',
	BREAK_BULK = 'BREAKBULK',
}

enum RfqModes {
  ALL = 'ALL',
  FCL = 'FCL',
  LCL = 'LCL',
  AIR = 'AIR',
  BREAK_BULK = 'BREAK_BULK',
}

const modeOptions = [
  { key: 'FCL', label: 'FCL' },
  { key: 'LCL', label: 'LCL' },
  { key: 'AIRCARGO', label: 'Air' },
  { key: 'DOMESTIC', label: 'Domestic' },
  { key: 'DOMESTIC', label: 'Road' },
  { key: 'RPTL', label: 'RPTL' },
  { key: 'BREAKBULK', label: 'Break Bulk' },
]

const sortByOptions = [
  { key: 'updated_at', label: 'Updated At' },
  { key: 'nearest_deadline', label: 'Deadline' }
]
const modeOfServiceOptions = [
  { key: 'FCL', label: 'FCL' },
  { key: 'LCL', label: 'LCL' },
  { key: 'AIRCARGO', label: 'Air' },
  { key: 'BREAKBULK', label: 'Break Bulk' },
  { key: 'ISO_TANKS', label: 'ISO Tanks' },
  { key: 'ROAD', label: 'Road' },
  { key: 'RAIL', label: 'Rail' },
];

const typeOptions = [
  { key: 'EXPORT', label: 'Export' },
  { key: 'IMPORT', label: 'Import' },
  { key: 'TRADE' , label: 'Trade' },
]

const myTaskOptions = [
  // { ket: 'ALL_TASKS', label: 'All Tasks'},
  { key: 'PENDING', label: 'Pending'},
  { key: 'DEADLINE_APPROACHING', label: 'Deadline Approaching'},
  { key: 'DEADLINE_ELAPSED', label: 'Deadline Elapsed'},
]

enum EximModules {
  CT = 'CT',
  RFQ = 'RFQ',
  BOOKING = 'BOOKING',
  INQUIRY = 'INQUIRY',
  EXECUTION = 'EXECUTION',  
}

export enum FinancingOptionsShipper {
  FREIGHT_FINANCING = 'FREIGHT_FINANCING',
  INVOICE_FINANCING = 'INVOICE_FINANCING',
}

export enum FinancingOptionsServiceProvider {
  FREIGHT_FACTORING = 'FREIGHT_FACTORING',
  EARLY_PAYMENT_TO_SUPPLIERS = 'EARLY_PAYMENT_TO_SUPPLIERS',
}

const DateFormats = [
  'DD-MM-YYYY',
  'DD-MMM-YY',
  'DD MMM YY',
  'DD-MMM-YYYY',
  'DD MMM YYYY',
  'DD/MM/YYYY',
  'DD-MM-YY',
  'DD/MM/YY',
  'MM/DD/YYYY',
  'MM-DD-YYYY',
  'MM/DD/YY',
  'MM-DD-YY',
  'YYYY-MM-DDTHH:mm:ss.sssZ',
  'YYYY-MM-DD',
  'YYYY-M-DD',
  'DD-M-YYYY',
  'DD/M/YYYY',
  'YYYY/M/DD',
  'YYYY/DD/M',
  'YYYY-DD-M',
  'YYYY-M-D',
  'D-M-YYYY',
  'D/M/YYYY',
  'YYYY/M/D',
  'YYYY/D/M',
  'YYYY-D-M',
  'YYYY-M-D HH:mm',
  'D-M-YYYY HH:mm',
  'D/M/YYYY HH:mm',
  'YYYY/M/D HH:mm',
  'YYYY/D/M HH:mm',
  'YYYY-D-M HH:mm',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DD HH:mm:ss',
  'DD-MM-YYYY HH:mm:ss',
  'DD-MM-YYYY HH:mm',
  'YYYY-M-D,HH:mm',
  'D-M-YYYY,HH:mm',
  'D/M/YYYY,HH:mm',
  'YYYY/M/D,HH:mm',
  'YYYY/D/M,HH:mm',
  'YYYY-D-M,HH:mm',
  'YYYY-MM-DD,HH:mm',
  'YYYY-MM-DD,HH:mm:ss',
  'DD-MM-YYYY,HH:mm:ss',
  'DD-MM-YYYY,HH:mm',
];

export const ContactUsURL = 'https://shipsy.io/contact-us/';

export {
  OrgTypes,
  RfqModes,
  SEARCH_TIMEOUT,
  accessOptions,
  CargoTypes,
  DEFAULT_ERROR_MESSAGE,
  PERMISSON_ERROR_MESSAGE,
  PortModule,
  AccessType,
  InquiryModes,
  InquiryType,
  CargoOperationType,
  LocationType,
  UserTags,
  UserRole,
  ModesOfService,
  modeOptions,
  typeOptions,
  myTaskOptions,
  EximModules,
  DateFormats,
  modeOfServiceOptions,
  OrgBasedModules,
  StakeholderTypes,
  VendorTypes,
  Modules,
  ModuleToPermissionMap,
  sortByOptions
};

export enum COUNTRY_CODE {
  INDIA = 'IND'
}

export const colorMappingForDelayChart = {
  'DELAYED (3 - 10 DAYS)': '#F47F7A',
  'DELAYED (<3 DAYS)': '#FFB8B6',
  'DELAYED (>10 DAYS)': '#ED283F',
  'ARRIVING EARLY': '#43C4E1',
  'EARLY ARRIVAL': '#43C4E1',
  'ON TIME': '#00AC4F',
};

export const colorMappingForVesselDepartureChart = {
  'To Depart' : '#FDB969',
  'Departed' : '#00AC4F',
  'Departure Pending (Event not available)' : '#838C94'
};

export enum ContainerTrackingFiltersSource {
  CUSTOM_DSR_TEMPLATE= 'CUSTOM_DSR_TEMPLATE',
  CONTAINER_TRACKING='CONTAINER_TRACKING'
}

export enum ShipmentStatus {
  ACTIVE='ACTIVE',
  INACTIVE='INACTIVE'
}
export const TypeOfServiceProvider = {
  "Freight Forwarder" : "Freight Forwarder",
  "Custom House Agent" : "Custom House Agent",
  "Trucking Agent" : "Trucking Agent",
  "Trade Consultant" : "Trade Consultant"
}

export const DistanceConverterMap = {
  meter: {
    meter: 1,
    km: 0.001,
    mi: 0.000621371,
  },
  km: {
    meter: 1000,
    km: 1,
    mi: 0.621371,
  },
  mi: {
    meter: 1609.34,
    km: 1.60934,
    mi: 1,
  },
};

export const ShipsySupportUrl = 'https://shipsy-help.freshdesk.com/support/home';

export const MAX_ALLOWED_DIFFERENCE_FOR_SHIPSY_PREDICTION = 6;

export const RECRONRELIANCE_ORGS = ['recronreliance', 'recronreliancetest'];

export const VALID_LOCATION_TYPES = {
  FACTORY: "Factory",
  DOCK_CFS_CUSTOMS_WAREHOUSE: "Dock/CFS/Customs Warehouse",
};

export enum ALLOWED_PICKUP_AND_DROP {
  PORT_TO_PORT = 'Port to Port',
  PORT_TO_DOOR = 'Port to Door',
  DOOR_TO_PORT = 'Door to Port',
  DOOR_TO_DOOR = 'Door to Door',
}

export enum PICKUP_AND_DROP_POINT {
  PORT = 'Port',
  DOOR = 'Door',
}

interface SplitupPoints {
  FROM: PICKUP_AND_DROP_POINT;
  TO: PICKUP_AND_DROP_POINT;
}

export const PICKUP_AND_DROP_SPLITUP: Record<ALLOWED_PICKUP_AND_DROP, SplitupPoints> = {
  [ALLOWED_PICKUP_AND_DROP.PORT_TO_PORT]: {
    FROM: PICKUP_AND_DROP_POINT.PORT,
    TO: PICKUP_AND_DROP_POINT.PORT,
  },
  [ALLOWED_PICKUP_AND_DROP.PORT_TO_DOOR]: {
    FROM: PICKUP_AND_DROP_POINT.PORT,
    TO: PICKUP_AND_DROP_POINT.DOOR,
  },
  [ALLOWED_PICKUP_AND_DROP.DOOR_TO_PORT]: {
    FROM: PICKUP_AND_DROP_POINT.DOOR,
    TO: PICKUP_AND_DROP_POINT.PORT,
  },
  [ALLOWED_PICKUP_AND_DROP.DOOR_TO_DOOR]: {
    FROM: PICKUP_AND_DROP_POINT.DOOR,
    TO: PICKUP_AND_DROP_POINT.DOOR,
  },
};
